import { bsh_isAdminUserDetailsPresent } from "helpers/sf_browser_storage_helper";
import { getProductTypeById, NAME_OF_PRODUCT_TYPES, REQUIRED_FEATURE_FLAGS } from "helpers/sf_constants";
import { UI_PERMISSION_KEY } from "pages/Roles/newFeaturesAndPermissionsData";
import { useCallback } from "react"
import { useSelector } from "react-redux"
import useClientPermissionsAccess from "./useClientPermissionsAccess"
import useFeatureFlags from "./useFeatureFlags";

const useCanManageCampaign = () => {
    const getActivePermissions = useClientPermissionsAccess();
    const [isFeatureFlagActive] = useFeatureFlags();

    const {
        campaigns,
        current_account
    } = useSelector(state => ({
        campaigns: state.Campaign.campaigns,
        current_account: state.accounts.current_account
    }))

    const canManageCampaign = useCallback((campaign_id) => {
        if (!getActivePermissions([UI_PERMISSION_KEY.MANAGE_CAMPAIGNS]).length) {
            return false;
        }

        if (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_RETAIL_CAMPAIGN_PAUSABLE)) {
            return true;
        }

        const campaign = campaigns.find(c => c.id == campaign_id);
        if (!campaign) {
            return false;
        }

        const product_type_name = getProductTypeById(campaign?.product_type_id)?.name;
        if (!current_account.enterprise &&
            !bsh_isAdminUserDetailsPresent() &&
            ((product_type_name === NAME_OF_PRODUCT_TYPES.CALLS && !campaign.call_campaign_setting?.pausable) ||
             (product_type_name === NAME_OF_PRODUCT_TYPES.LEADS && !campaign.lead_campaign_setting?.pausable))) {
                return false;
        }

        return true
    }, [campaigns, current_account, getActivePermissions])

    return canManageCampaign;
}

export default useCanManageCampaign;
